module.exports = __webpack_public_path__ + "static/media/flaskEmpty.f3862dca.svg";